import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostErforderlichesDokumentCommandServiceModule } from '..';
import { PostErforderlichesDokumentCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostErforderlichesDokumentCommandServiceModule
  ],
  declarations: [PostErforderlichesDokumentCommandComponent],
  exports: [PostErforderlichesDokumentCommandComponent],

})
export class PostErforderlichesDokumentCommandComponentModule { }
